"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _questionBuilder = require("@pcty/question-builder");
var _reactQuestion = _interopRequireDefault(require("@pcty/react-question"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PctyQuestionBuilderEditConditionalQuestion = function PctyQuestionBuilderEditConditionalQuestion(_ref) {
  var triggerQuestion = _ref.triggerQuestion,
    _onResponse = _ref.onResponse,
    response = _ref.response;
  var renderTriggerQuestion = function renderTriggerQuestion() {
    if (!triggerQuestion) return null;
    var view = null;
    var number = 0;
    var question = _objectSpread({}, triggerQuestion);
    question.question = ''; // clear out the text so it doesn't display!

    switch (question.typeId) {
      case _questionBuilder.QUESTION_TYPE.multipleChoice:
        view = /*#__PURE__*/_react.default.createElement(_reactQuestion.default.MultipleChoice, (0, _extends2.default)({}, question, {
          response: response || [],
          onResponse: function onResponse(id, resp) {
            return _onResponse(id, resp);
          },
          number: number
        }));
        break;
      case _questionBuilder.QUESTION_TYPE.dropdownList:
        view = /*#__PURE__*/_react.default.createElement(_reactQuestion.default.DropdownList, (0, _extends2.default)({}, question, {
          placeholder: question.questionPlaceholder || "Select...",
          response: response || [],
          onResponse: function onResponse(id, resp) {
            return _onResponse(id, resp);
          },
          number: number
        }));
        break;
      case _questionBuilder.QUESTION_TYPE.checkbox:
        view = /*#__PURE__*/_react.default.createElement(_reactQuestion.default.Checkbox, (0, _extends2.default)({}, question, {
          response: response,
          onResponse: function onResponse(id, resp) {
            return _onResponse(id, resp);
          },
          number: number
        }));
        break;
      case _questionBuilder.QUESTION_TYPE.starRating:
        view = /*#__PURE__*/_react.default.createElement(_reactQuestion.default.StarRating, (0, _extends2.default)({}, question, {
          response: response || 0,
          onResponse: function onResponse(id, resp) {
            return _onResponse(id, resp);
          },
          number: number
        }));
        break;
      case _questionBuilder.QUESTION_TYPE.ratingScale:
        view = /*#__PURE__*/_react.default.createElement(_reactQuestion.default.RatingScale, (0, _extends2.default)({}, question, {
          response: response || 0,
          onResponse: function onResponse(id, resp) {
            return _onResponse(id, resp);
          },
          number: number
        }));
        break;
    }
    return view;
  };
  return renderTriggerQuestion();
};
PctyQuestionBuilderEditConditionalQuestion.propTypes = {
  onResponse: _propTypes.default.func.isRequired,
  response: _propTypes.default.any,
  triggerQuestion: _propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    typeId: _propTypes.default.number.isRequired,
    scenario: _propTypes.default.string,
    question: _propTypes.default.string.isRequired,
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string.isRequired,
      value: _propTypes.default.string.isRequired
    })),
    answers: _propTypes.default.arrayOf(_propTypes.default.shape({
      optionId: _propTypes.default.string.isRequired
    })),
    knockout: _propTypes.default.bool,
    hint: _propTypes.default.string,
    correctFeedback: _propTypes.default.string,
    incorrectFeedback: _propTypes.default.string
  })
};
var _default = exports.default = PctyQuestionBuilderEditConditionalQuestion;